module.exports = {
  "zones": {
    "Pacific/Chatham": ["z", {
      "wallclock": -757382400000,
      "format": "+1245/+1345",
      "abbrev": "+1245",
      "offset": 45900000,
      "posix": -757426500000,
      "save": 0,
      "rules": "Chatham"
    }, {
      "wallclock": -3192393600000,
      "format": "+1215",
      "abbrev": "+1215",
      "offset": 44100000,
      "posix": -3192437628000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 44028000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Chatham": [{
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 8,
      "day": [0, -30],
      "time": 165,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2008,
      "to": 1.7976931348623157e+308,
      "month": 3,
      "day": [0, 1],
      "time": 225,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1990,
      "to": 2007,
      "month": 2,
      "day": [0, 15],
      "time": 225,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1990,
      "to": 2006,
      "month": 9,
      "day": [0, 1],
      "time": 165,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1976,
      "to": 1989,
      "month": 2,
      "day": [0, 1],
      "time": 225,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1989,
      "to": 1989,
      "month": 9,
      "day": [0, 8],
      "time": 165,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1975,
      "to": 1988,
      "month": 9,
      "day": [0, -31],
      "time": 165,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1975,
      "to": 1975,
      "month": 1,
      "day": [0, -29],
      "time": 225,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1974,
      "to": 1974,
      "month": 10,
      "day": [0, 1],
      "time": 165,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }]
  }
};